/* gh-buybox.js — PDP købsboks-controller.

   Mapper leveringsvalg (Levering-option) + mængde-stepper (Mængde-option) til
   produktets varianter, viser variantens pris + FRAGT, og lægger den resolvede
   variant i kurven.

   Fragten beregnes IKKE her. Al prislogik ligger i window.GHFreight
   (assets/gh-freight-core.js), som er genereret fra samme kilde som
   checkout-workeren — så buyboxen og kassen aldrig kan vise forskellige tal.

   Tre ting adskiller den fra en almindelig buybox:
   1. BigBag har to undertyper (palle/kran) med hver sin fragtpris. De vises
      først når BigBag er valgt.
   2. Mængderabatten på fragt gælder PÅ TVÆRS AF MATERIALER, så boksen læser
      kurven og regner med de bags der allerede ligger der.
   3. Fragttabellen er ikke-monoton: nogle gange bliver den SAMLEDE fragt
      billigere af at købe en bag mere. Det siger vi aktivt.

   Prisenheden følger leveringsmetoden: flis (m³-produkter) vises i m³ ved
   Grab/Aftippet og i bigbags ved BigBag; grus vises altid i ton. Det er KUN
   visning — _gh_bags sendes altid som bag-antal til fragt-workeren.

   På mobil (≤749px, styret af CSS) får siden en sticky køb-bar når den rigtige
   CTA er scrollet forbi. Baren har ingen egen kurv-logik: den klikker CTA'en.

   Postnr deles med kurv og beregner via localStorage ('gh:postnr').
   Idempotent + theme-editor-sikker (re-init på shopify:section:load). */
(function () {
  'use strict';

  var PC_KEY = 'gh:postnr';
  var GROUPS = { grab: 'grab', bigbag: null, aftippet: 'aftippet' }; // bigbag afgøres af undervalg

  function F() { return window.GHFreight || null; }

  function storedPc() {
    try { return window.localStorage.getItem(PC_KEY) || ''; } catch (e) { return ''; }
  }
  function storePc(pc) {
    try {
      if (pc) window.localStorage.setItem(PC_KEY, pc);
      else window.localStorage.removeItem(PC_KEY);
    } catch (e) { /* private mode */ }
  }

  function kr(ore) {
    return Math.round(ore / 100).toLocaleString('da-DK') + ' kr';
  }

  // "4 tons | 2.7m3" → 4 · "2.4 m3" → 4 (bags à 0,6 m³) · ellers null
  function parseUnits(m) {
    var s = String(m);
    var t = s.match(/^(\d+)\s*tons?\b/i);
    if (t) return parseInt(t[1], 10);
    var v = s.match(/^(\d+(?:[.,]\d+)?)\s*m3/i);
    if (v) return Math.round(parseFloat(v[1].replace(',', '.')) / 0.6);
    return null;
  }
  function isM3(m) { return /^\d+(?:[.,]\d+)?\s*m3/i.test(String(m)); }

  function refreshCart(sections) {
    if (!sections) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('active', 'animate');
      }
    }
  }

  function initRoot(root) {
    if (root.dataset.ghBuyboxReady === '1') return;
    root.dataset.ghBuyboxReady = '1';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-gh-variants]').textContent); } catch (e) { variants = []; }
    if (!variants.length) return;

    var m3Product = variants.some(function (v) { return isM3(v.m); });

    var units = [];
    variants.forEach(function (v) {
      var u = parseUnits(v.m);
      if (u != null && u > 0 && units.indexOf(u) === -1) units.push(u);
    });
    units.sort(function (a, b) { return a - b; });
    var maxUnits = units.length ? units[units.length - 1] : 1;

    /** Variant for (antal, fragttype). Levering-værdien normaliseres via motoren,
     *  så både "Bigbag palle" og den gamle værdi "Bigbag" rammer palle. */
    function variantFor(u, kind) {
      var f = F();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (parseUnits(v.m) !== u) continue;
        var k = f ? f.normalizeKind(v.l) : String(v.l).toLowerCase();
        if (k === kind) return v;
      }
      return null;
    }
    function anyVariantFor(u) {
      for (var i = 0; i < variants.length; i++) {
        if (parseUnits(variants[i].m) === u) return variants[i];
      }
      return null;
    }

    var els = {
      pc: root.querySelector('[data-gh-pc-input]'),
      pcStatus: root.querySelector('[data-gh-pc-status]'),
      methodBtns: Array.prototype.slice.call(root.querySelectorAll('[data-gh-method]')),
      subWrap: root.querySelector('[data-gh-submethods]'),
      subBtns: Array.prototype.slice.call(root.querySelectorAll('[data-gh-sub]')),
      qtyVal: root.querySelector('[data-gh-qty]'),
      qtyUnit: root.querySelector('.qty-unit'),
      steps: Array.prototype.slice.call(root.querySelectorAll('[data-gh-step]')),
      total: root.querySelector('[data-gh-total]'),
      totalUnit: root.querySelector('[data-gh-total-unit]'),
      perTon: root.querySelector('[data-gh-perton]'),
      addBtn: root.querySelector('[data-gh-add]'),
      addLabel: root.querySelector('[data-gh-add-label]'),
      fBox: root.querySelector('[data-gh-freight-box]'),
      fLabel: root.querySelector('[data-gh-freight-label]'),
      fAmount: root.querySelector('[data-gh-freight-amount]'),
      fTotal: root.querySelector('[data-gh-delivered-total]'),
      fTip: root.querySelector('[data-gh-freight-tip]'),
      cartCtx: root.querySelector('[data-gh-cart-context]'),
      cartNote: root.querySelector('[data-gh-cart-note]'),
      methods: root.querySelector('[data-gh-methods]')
    };

    // group = grab | bigbag | aftippet (det kunden klikker på)
    // sub   = palle | kran (kun når group === 'bigbag')
    // kind  = den fragttype motoren regner på
    var state = { qty: 1, group: null, sub: 'palle', zone: null, cart: null };

    /** Visningsenhed for state.qty bags. Flis måles i m³ (0,6 pr. bag) undtagen
     *  ved BigBag, hvor kunden køber hele sække; grus er 1 ton pr. bag. */
    function unitInfo() {
      if (m3Product && state.group !== 'bigbag') {
        return {
          amount: (Math.round(state.qty * 6) / 10).toLocaleString('da-DK'),
          word: 'm³', per: 'm³', perCount: state.qty * 0.6
        };
      }
      if (m3Product) {
        return { amount: String(state.qty), word: state.qty === 1 ? 'bigbag' : 'bigbags', per: 'bigbag', perCount: state.qty };
      }
      return { amount: String(state.qty), word: 'ton', per: 'ton', perCount: state.qty };
    }

    function kindOf() {
      if (!state.group) return null;
      return state.group === 'bigbag' ? state.sub : GROUPS[state.group];
    }

    /** Bags der allerede ligger i kurven af en given fragttype. */
    function cartBags(kind) {
      return (state.cart && state.cart[kind]) || 0;
    }

    function groupAvail(g) {
      if (!state.zone) return false;
      return g === 'bigbag' ? true : state.zone.d >= 0;
    }
    function groupReason(g) {
      if (!state.zone) return (els.pc && els.pc.value.length === 4) ? 'Uden for område' : 'Indtast postnr.';
      if (!groupAvail(g)) return 'Ikke i dit område';
      var btn = root.querySelector('[data-gh-method="' + g + '"]');
      return btn ? btn.dataset.desc : '';
    }

    /** Fragt for DENNE tilføjelse: forskellen mellem kurvens fragt før og efter. */
    function marginalOre(kind, addBags) {
      var f = F();
      if (!f || !state.zone) return null;
      if (kind === 'grab' || kind === 'aftippet') {
        if (state.zone.d < 0) return null;
        // Læs-pris: allerede betalt hvis der er samme type i kurven.
        var have = cartBags(kind);
        var before = have > 0 ? f.looseOre(kind, have, state.zone.d) : 0;
        var after = f.looseOre(kind, have + addBags, state.zone.d);
        if (after == null) return null;
        return after - (before || 0);
      }
      var m = f.marginal(kind, cartBags(kind), addBags, state.zone);
      return m ? m.deltaOre : null;
    }

    function methodFreightLabel(g) {
      var kind = g === 'bigbag' ? state.sub : GROUPS[g];
      var ore = marginalOre(kind, state.qty);
      if (ore === null) return null;
      if (g === 'bigbag') return ore === 0 && cartBags(kind) === 0 ? 'Fri fragt' : 'Fragt ' + kr(ore);
      return cartBags(kind) > 0 ? 'Samme læs ✓' : 'Fragt ' + kr(ore) + ' pr. læs';
    }

    function renderMethods() {
      els.methodBtns.forEach(function (btn) {
        var g = btn.dataset.ghMethod;
        var ok = groupAvail(g);
        btn.classList.toggle('is-active', ok && state.group === g);
        btn.classList.toggle('is-disabled', !ok);
        btn.disabled = !ok;
        var small = btn.querySelector('small');
        if (small) small.textContent = ok ? (methodFreightLabel(g) || btn.dataset.desc) : groupReason(g);
      });

      var showSub = state.group === 'bigbag';
      if (els.subWrap) els.subWrap.hidden = !showSub;
      els.subBtns.forEach(function (btn) {
        var s = btn.dataset.ghSub;
        btn.classList.toggle('is-active', state.sub === s);
        var small = btn.querySelector('small');
        if (!small) return;
        var ore = showSub ? marginalOre(s, state.qty) : null;
        small.textContent = ore === null ? btn.dataset.desc : kr(ore);
      });
    }

    function renderFreight(resolved) {
      if (!els.fBox) return;
      var kind = kindOf();
      var ore = (resolved && kind) ? marginalOre(kind, state.qty) : null;
      if (!resolved || ore === null) {
        els.fBox.hidden = true;
        return;
      }
      els.fBox.hidden = false;

      var have = cartBags(kind);
      if (els.cartCtx && els.cartNote) {
        if (have > 0) {
          els.cartCtx.hidden = false;
          els.cartNote.textContent = kind === 'grab' || kind === 'aftippet'
            ? 'Du har allerede et ' + (kind === 'grab' ? 'grab' : 'aftippet') + '-læs i kurven'
            : 'Du har allerede ' + have + ' ' + (have === 1 ? 'bigbag' : 'bigbags') + ' i kurven';
        } else {
          els.cartCtx.hidden = true;
        }
      }

      if (els.fLabel) els.fLabel.textContent = have > 0 ? 'Fragt for disse' : 'Fragt';
      els.fAmount.textContent = ore === 0 ? (have > 0 ? 'Ingen ekstra fragt ✓' : 'Fri fragt ✓') : kr(ore);
      els.fTotal.textContent = kr(resolved.price + ore);

      // Tabellen er ikke-monoton: nogle gange falder den samlede fragt af at
      // købe mere. Sig det — det er en reel besparelse, ikke en fejl.
      var f = F();
      var tip = null;
      if (f && (kind === 'palle' || kind === 'kran')) {
        var c = f.cheaperAbove(kind, have + state.qty, state.zone);
        if (c && c.saveOre > 0) {
          var extra = c.atBags - (have + state.qty);
          tip = 'Læg ' + extra + ' ' + (extra === 1 ? 'bigbag' : 'bigbags') +
            ' mere i kurven og spar ' + kr(c.saveOre) + ' i fragt';
        }
      }
      if (els.fTip) {
        els.fTip.hidden = !tip;
        els.fTip.textContent = tip || '';
      }
    }

    function update() {
      var u = unitInfo();
      els.qtyVal.textContent = u.amount;
      if (els.qtyUnit) els.qtyUnit.textContent = u.word;
      var kind = kindOf();
      var resolved = (kind && groupAvail(state.group)) ? variantFor(state.qty, kind) : null;
      var shown = resolved || anyVariantFor(state.qty);
      if (shown) {
        els.total.textContent = shown.pf;
        if (els.perTon) {
          els.perTon.textContent = Math.round(shown.price / u.perCount / 100).toLocaleString('da-DK')
            + ' kr / ' + u.per;
        }
      }
      els.totalUnit.textContent = 'i alt for ' + u.amount + ' ' + u.word;
      renderFreight(resolved);

      var canAdd = !!(resolved && resolved.available);
      els.addBtn.disabled = !canAdd;
      root._ghVariantId = canAdd ? resolved.id : null;
      root._ghKind = kind;
      root._ghBags = state.qty;
      if (els.addLabel) {
        els.addLabel.textContent = canAdd ? 'Læg i kurv'
          : (!state.group ? 'Vælg leveringsmetode' : 'Ikke tilgængelig');
      }
      syncBar();
    }

    // ---- Sticky køb-bar (mobil) ------------------------------------------
    // Flyttes ud til <body>: Dawns .scroll-trigger giver produktkolonnen en
    // transform, og så ville position:fixed klæbe til kolonnen, ikke skærmen.
    var bar = root.querySelector('[data-gh-buybar]');
    if (bar) {
      // Theme-editoren genrenderer sektionen; ryd barer hvis buybox er væk.
      Array.prototype.forEach.call(document.querySelectorAll('body > [data-gh-buybar]'), function (old) {
        if (!old._ghRoot || !old._ghRoot.isConnected) old.remove();
      });
      if (document.querySelector('body > [data-gh-buybar]')) { // én pr. side
        bar.remove();
        bar = null;
      }
    }
    var barEls = bar && {
      total: bar.querySelector('[data-gh-bar-total]'),
      unit: bar.querySelector('[data-gh-bar-unit]'),
      btn: bar.querySelector('[data-gh-bar-add]'),
      label: bar.querySelector('[data-gh-bar-label]')
    };

    function setBarVisible(on) {
      if (!bar) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    function syncBar() {
      if (!barEls) return;
      // Kendes fragten, viser baren prisen leveret til døren — det tal kunden
      // reelt betaler, og kort nok til at stå uklippet på en 360px skærm.
      var u = unitInfo();
      if (els.fBox && !els.fBox.hidden && els.fTotal.textContent) {
        barEls.total.textContent = els.fTotal.textContent;
        barEls.unit.textContent = u.amount + ' ' + u.word + ' · inkl. fragt';
      } else {
        barEls.total.textContent = els.total.textContent;
        barEls.unit.textContent = els.totalUnit.textContent;
      }
      if (root._ghVariantId) {
        barEls.label.textContent = els.addLabel ? els.addLabel.textContent : 'Læg i kurv';
      } else {
        barEls.label.textContent = !state.zone ? 'Indtast postnr.'
          : (!state.group ? 'Vælg levering' : 'Ikke tilgængelig');
      }
      barEls.btn.classList.toggle('btn-yellow', els.addBtn.classList.contains('btn-yellow'));
      barEls.btn.classList.toggle('btn-primary', !els.addBtn.classList.contains('btn-yellow'));
    }

    if (bar) {
      bar._ghRoot = root;
      document.body.appendChild(bar);
      bar.hidden = false;
      document.body.classList.add('gh-has-buybar');
      setBarVisible(false);

      // Mangler der et valg, sender baren kunden op til det felt i stedet for
      // at være en død knap. Ellers klikker den den rigtige CTA.
      barEls.btn.addEventListener('click', function () {
        if (root._ghVariantId) { els.addBtn.click(); return; }
        var target = !state.zone ? els.pc : els.methods;
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (target === els.pc) setTimeout(function () { els.pc.focus({ preventScroll: true }); }, 350);
      });

      // Kun når CTA'en er scrollet FORBI (ligger over skærmen) — ikke før
      // kunden har nået købsboksen. Scroll-lytter frem for IntersectionObserver:
      // et hurtigt fling kan hoppe CTA'en fra under til over skærmen uden at
      // den nogensinde krydser kanten, og så fyrer en observer aldrig.
      var cta = els.addBtn.closest('.buy-cta') || els.addBtn;
      var ticking = false;
      var checkBar = function () {
        ticking = false;
        if (!bar.isConnected) return window.removeEventListener('scroll', onScroll);
        setBarVisible(cta.getBoundingClientRect().bottom < 0);
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; requestAnimationFrame(checkBar); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      checkBar();
    }

    /** Kurvens bags pr. fragttype — grundlaget for mængderabat på tværs. */
    function loadCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var f = F();
          var groups = f ? f.emptyGroups() : { palle: 0, kran: 0, grab: 0, aftippet: 0 };
          if (cart && cart.items && f) {
            cart.items.forEach(function (it) {
              var lev = null;
              (it.options_with_values || []).forEach(function (o) {
                if (o.name === 'Levering') lev = o.value;
              });
              var kind = f.normalizeKind(lev);
              var bags = parseUnits(
                (it.options_with_values || []).reduce(function (acc, o) {
                  return o.name === 'Mængde' ? o.value : acc;
                }, '')
              );
              if (kind && bags) groups[kind] += bags * (it.quantity || 1);
            });
          }
          state.cart = groups;
          return groups;
        })
        .catch(function () { state.cart = null; });
    }

    function evalPostcode() {
      if (!els.pc) return;
      var pc = els.pc.value;
      var f = F();
      if (pc.length === 4 && f) {
        state.zone = f.zoneFor(pc);
        els.pcStatus.hidden = false;
        if (state.zone) {
          storePc(pc);
          els.pcStatus.className = 'pc-status is-ok';
          els.pcStatus.textContent = '✓ Vi leverer til ' + pc + ' · ' + state.zone.label;
        } else {
          els.pcStatus.className = 'pc-status is-no';
          els.pcStatus.textContent = '✕ Vi leverer ikke til ' + pc + ' endnu';
        }
      } else {
        state.zone = null;
        els.pcStatus.hidden = true;
      }
      if (state.group && !groupAvail(state.group)) state.group = null;
      renderMethods();
      update();
    }

    if (els.pc) {
      els.pc.addEventListener('input', function () {
        els.pc.value = els.pc.value.replace(/\D/g, '').slice(0, 4);
        evalPostcode();
      });
    }

    els.methodBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.dataset.ghMethod;
        if (!groupAvail(g)) return;
        state.group = g;
        renderMethods();
        update();
      });
    });

    els.subBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.sub = btn.dataset.ghSub;
        renderMethods();
        update();
      });
    });

    els.steps.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.dataset.ghStep, 10);
        state.qty = Math.min(maxUnits, Math.max(1, state.qty + d));
        renderMethods();
        update();
      });
    });

    if (els.addBtn) {
      els.addBtn.addEventListener('click', function () {
        var id = root._ghVariantId;
        if (!id) return;
        els.addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: id,
            quantity: 1,
            // Læses af checkout-workeren som primær kilde til fragttype og antal.
            properties: { _gh_kind: root._ghKind, _gh_bags: root._ghBags },
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            refreshCart(data.sections);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gh-buybox' });
            }
            els.addBtn.classList.remove('btn-primary');
            els.addBtn.classList.add('btn-yellow');
            if (els.addLabel) els.addLabel.textContent = 'Lagt i kurv ✓';
            syncBar();
            return loadCart();
          })
          .then(function () {
            setTimeout(function () {
              els.addBtn.classList.remove('btn-yellow');
              els.addBtn.classList.add('btn-primary');
              renderMethods();
              update();
            }, 1500);
          })
          .catch(function () { els.addBtn.disabled = false; window.location.href = '/cart'; });
      });
    }

    // Kurven kan ændres andre steder fra (drawer, /cart) — hold konteksten frisk.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.source === 'gh-buybox') return;
        loadCart().then(function () { renderMethods(); update(); });
      });
    }

    if (els.pc && !els.pc.value && storedPc()) els.pc.value = storedPc();
    loadCart().then(function () { evalPostcode(); });
    renderMethods();
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-gh-buybox]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
